import { formatSnakeValue } from 'src/lib/formatters'

export enum CustomQuestionFieldType {
  SHORT_TEXT = 'SHORT_TEXT',
  LONG_TEXT = 'LONG_TEXT',
  BOOLEAN = 'BOOLEAN',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
}

export enum CustomQuestionVisibility {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export enum CustomQuestionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export const CustomQuestionFieldTypeLabels: Record<
  CustomQuestionFieldType,
  string
> = {
  [CustomQuestionFieldType.SHORT_TEXT]: 'Text',
  [CustomQuestionFieldType.LONG_TEXT]: 'Long Text',
  [CustomQuestionFieldType.BOOLEAN]: 'Yes / No',
  [CustomQuestionFieldType.SINGLE_SELECT]: 'Single Select',
  [CustomQuestionFieldType.MULTI_SELECT]: 'Multi Select',
}

export const formatCustomQuestionFieldType = (
  fieldType: CustomQuestionFieldType | string
): string => {
  if (!fieldType) return ''

  if (fieldType in CustomQuestionFieldTypeLabels) {
    return CustomQuestionFieldTypeLabels[fieldType as CustomQuestionFieldType]
  }

  return formatSnakeValue(fieldType)
}
